/*Jquery Scroll Spy*/
/**
 * A jQuery Plugin for a ScrollSpy Navigation.
 * v1.0.1
 * MIT license
 *
 */
!(function ($) {
	$.fn.scrollSpy = function (c) {
		var d = $('html'),
			e = d.css('scroll-behavior'),
			a = $.extend(
				{
					offset: 0,
					offsetElement: null,
					activeClass: 'active',
					anchors: ['a[href*=\\#]'],
					ignoreAnchors: [],
					scrollDuration: 0,
					scrollEasing: 'swing',
				},
				c
			)
		void 0 === $.ui && (a = $.extend(a, { scrollEasing: 'swing' }))
		var f = function (c) {
				var b = $(c)
				b.length &&
					(d.css('scroll-behavior', 'unset'),
					d.animate(
						{ scrollTop: b.offset().top - a.offset },
						{ duration: a.scrollDuration, easing: a.scrollEasing }
					),
					setTimeout(function () {
						d.css('scroll-behavior', e)
					}, a.scrollDuration))
			},
			b = function () {
				$(a.offsetElement).length &&
					(a = $.extend(a, { offset: $(a.offsetElement).height() }))
			}
		return (
			b(),
			$(window).on('resize', b),
			$(window).on('load', function () {
				location.hash && f(location.hash)
			}),
			this.each(function () {
				var e = this,
					d = $(),
					g = [],
					h = void 0
				Array.isArray(a.anchors) &&
					a.anchors.forEach(function (a) {
						d = d.add($(e).find(a))
					}),
					Array.isArray(a.ignoreAnchors) &&
						a.ignoreAnchors.forEach(function (a) {
							d = d.filter(':not(' + a + ')')
						})
				var b = function () {
					d.each((c, b) => {
						var a = $(b.hash)
						a.length &&
							g.push({
								navElement: b,
								targetOffset: a.offset(),
								targetHeight: a.outerHeight(),
							})
					}),
						g.sort(function (a, b) {
							return a.targetOffset.top - b.targetOffset.top
						}),
						g.reverse()
				}
				b(), $(window).on('resize', b)
				var c = function () {
					var c = $(document).scrollTop() + a.offset,
						b = g.find(function (a) {
							if (
								a.targetOffset.top <= c &&
								a.targetOffset.top + a.targetHeight >= c
							)
								return !0
						})
					b && b.navElement != h
						? ($(h).removeClass(a.activeClass),
						  $(b.navElement).addClass(a.activeClass),
						  (h = b.navElement))
						: b || ($(h).removeClass(a.activeClass), (h = void 0))
				}
				c(),
					$(document).on('scroll', c),
					d.click(function (a) {
						a.preventDefault()
						var b = a.currentTarget.hash
						history.pushState({}, '', b), f(b)
					})
			})
		)
	}
})(jQuery)

// let parent = document.querySelector('.widget').parentElement

// while (parent) {
// 	const hasOverflow = getComputedStyle(parent).overflow
// 	if (hasOverflow !== 'visible') {
// 		console.log(hasOverflow, parent)
// 	}
// 	parent = parent.parentElement
// }

// $(document).ready(function () {
// 	$('.product-image .image').css(
// 		'margin-top',
// 		'-' + $('.widget').height() + 'px'
// 	)
// 	$('.widget-wrap').scrollSpy({
// 		offsetElement: '#main-header',
// 		offset: 50,
// 		scrollDuration: 1000,
// 		scrollEasing: 'swing',
// 	})

// 	setTimeout(function () {
// 		$('.shopify-payment-button__button--unbranded').text('BUY NOW')
// 	}, 2000)

// 	if ($(window).width() < 768) {
// 		var $windowheight = $(window).height()
// 		var $headerheight = $('#shopify-section-header').outerHeight()
// 		var $announcementheight = $('.announcement-bar').outerHeight()
// 		var $imgOffset = $headerheight + $announcementheight
// 		var $productinfoheight = 178.5
// 		var $newImageHeight = $windowheight - $imgOffset - $productinfoheight + 5

// 		var $image = $('.product-image.mobile .swiper-slide').find('img')

// 		$image.each(function () {
// 			$(this).height($newImageHeight)
// 		})

// 		$('.product-image.mobile .videoWrapper').height($newImageHeight)

// 		var $video = $('.product-image.mobile .videoWrapper')
// 		var $vwidth = $video.width()
// 		var $vheight = $video.height()

// 		var $setting1 = { ratio_x: 4, ratio_y: 5 }
// 		var $setting

// 		if ($vheight > $vwidth) {
// 			$setting = $setting1
// 		}

// 		$video.videoBackground($setting)
// 	}

$('#prod-desc-details .desc-details-title').click(function (e) {
	$('#prod-desc-details .desc-details-title').not($(this)).removeClass('show')

	$(this).toggleClass('show')

	$(this).next('.prod-desc-content').siblings('.prod-desc-content').hide()

	$(this).next('.prod-desc-content').show()
})
$('#prod-desc-details .desc-details-title:first-child').addClass('show')
$('#prod-desc-details .prod-desc-content:nth-child(2)').css('display', 'block')

$('.with-addon').click(function () {
	setTimeout(function () {
		$('#add-onn').trigger('submit')
		$('#add-onn').submit()
	}, 1000)
})
// })

var swiper = new Swiper('.swatches .swiper-container', {
	slidesPerView: 'auto',
	spaceBetween: 5,
})
var productImageThumbnails = new Swiper('[data-thumbnails-swiper]', {
	spaceBetween: 3,
	watchSlidesProgress: true,
	direction: 'vertical',
	height: 'auto',
})

var productImageMobile = new Swiper('[data-product-swiper]', {
	slidesPerView: 1,
	speed: 800,
	spaceBetween: 12,
	direction: 'horizontal',
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	pagination: {
		el: '.swiper-pagination',
	},
	thumbs: {
		swiper: productImageThumbnails,
	},
	breakpoints: {
		768: {
			direction: 'vertical',
		},
	},
})

var swiper = new Swiper('#product-recomended .swiper-container', {
	slidesPerView: 'auto',
	spaceBetween: 10,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
})
